import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

// API base URL'i ayarla - development'ta localhost, production'da domain
const API_URL = process.env.REACT_APP_API_URL || (
  process.env.NODE_ENV === 'production' 
    ? 'https://uiquarter.com' 
    : 'http://localhost:4001'
);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuthStatus = async () => {
            const token = localStorage.getItem('adminToken');
            if (token) {
                try {
                    // Token'ı axios default header'ına ekle
                    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                    
                    // Backend'den token'ı doğrula
                    const response = await axios.get(`${API_URL}/api/admin/verify`);
                    
                    if (response.data.admin) {
                        // Token geçerli, admin bilgilerini set et
                        setUser(response.data.admin);
                        localStorage.setItem('adminUser', JSON.stringify(response.data.admin));
                    } else {
                        // Token geçersiz, temizle
                        localStorage.removeItem('adminToken');
                        localStorage.removeItem('adminUser');
                        delete axios.defaults.headers.common['Authorization'];
                        setUser(null);
                    }
                } catch (error) {
                    console.error('Token verification error:', error);
                    // Token geçersiz veya hata, logout yap
                    localStorage.removeItem('adminToken');
                    localStorage.removeItem('adminUser');
                    delete axios.defaults.headers.common['Authorization'];
                    setUser(null);
                }
            }
            setLoading(false);
        };
        
        checkAuthStatus();
    }, []);

    const login = async (email, password) => {
        try {
            const response = await axios.post(`${API_URL}/api/admin/login`, {
                email,
                password
            });

            const { token, admin: adminData } = response.data;
            
            // Token'ı ve admin bilgilerini kaydet
            localStorage.setItem('adminToken', token);
            localStorage.setItem('adminUser', JSON.stringify(adminData));
            
            // Axios default header'ına token'ı ekle
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            
            setUser(adminData);
            
            return { success: true };
        } catch (error) {
            console.error('Login error:', error);
            return { 
                success: false, 
                error: error.response?.data?.message || 'Login failed' 
            };
        }
    };

    const logout = () => {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');
        delete axios.defaults.headers.common['Authorization'];
        setUser(null);
    };

    const value = {
        user,
        loading,
        login,
        logout
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}; 